import { render } from "./PropertyUnits.vue?vue&type=template&id=698a1fa1"
import script from "./PropertyUnits.vue?vue&type=script&lang=js"
export * from "./PropertyUnits.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__